module.exports = __webpack_public_path__ + "static/media/subGoogle2.ec9a66ff.png";